import styled, { css, RuleSet } from 'styled-components';
import { Loader as LoaderComponent } from 'src/components';
import theme from 'src/utils/theme';

export const BackgroundWrapper = styled.div<{ $background?: RuleSet<object> }>(
  ({ $background }) => $background,
);

export const HeaderWrapper = styled.div(
  ({ theme }) => css`
    color: ${theme.co.secondary20};
  `,
);

export const LanguageFilterWrapper = styled.div(
  ({ theme }) => css`
    margin: 0 0 0 ${theme.sz.s4};
    white-space: nowrap;

    @media (max-width: ${theme.sz.md}) {
      margin: 0;
    }
  `,
);

export const Loader = styled(LoaderComponent)(
  ({ theme }) => css`
    height: ${theme.sz.s12};
  `,
);

export const FullWidthFloatingPortal = styled.div(
  ({ theme }) => css`
    width: 100%;
    position: fixed;
    bottom: 0;
    z-index: ${theme.zi.z5};
  `,
);

/* istanbul ignore next: tested visually */
export const PageWithSidebarFloatingPortal = styled(FullWidthFloatingPortal)<{
  $width: number | null;
}>(({ theme, $width }) =>
  $width
    ? css`
        width: calc(${$width + 'px'} + ${theme.sz.s16});
        margin-left: -${theme.sz.s8};

        @media (max-width: ${theme.sz.md}) {
          width: calc(${$width + 'px'} + ${theme.sz.s8});
          margin-left: -${theme.sz.s4};
        }

        @media (max-width: ${theme.sz.maxMobileBreakpoint}) {
          bottom: ${theme.sz.s16};
        }
      `
    : css``,
);

export const getHomeContentBackground = (backgroundImage?: string | undefined) => css`
  background-color: ${theme.co.primary99};

  ${
    /* istanbul ignore next: tested visually */ backgroundImage &&
    css`
      background-image: url('${backgroundImage}');
      background-attachment: fixed;
      background-position: right bottom;
      background-repeat: no-repeat;
      background-size: ${theme.sz.lg} auto;
      margin-bottom: calc(${theme.sz.lg} / 2);

      @media (max-width: ${theme.sz.xxl}) {
        background-size: ${theme.sz.md} auto;
        margin-bottom: calc(${theme.sz.md} / 2);
      }

      @media (max-width: ${theme.sz.maxMobileBreakpoint}) {
        background-position: right bottom ${theme.sz.s16};
        margin-bottom: calc(${theme.sz.md} / 2 + ${theme.sz.s16});
      }

      @media (max-width: ${theme.sz.md}) {
        background-size: 100vw auto;
        background-position: right bottom ${theme.sz.s44};
        margin-bottom: calc(100vw / 2 + ${theme.sz.s44});
      }
    `
  }
`;

export const getProgressContentBackground = (backgroundImage?: string | undefined) => css`
  background-image: url('${backgroundImage}');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

export const FlagImageWrapper = styled.button(
  ({ theme }) => css`
    background: none;
    border-radius: ${theme.bo.round};
    cursor: pointer;
    border: none;
    display: flex;
    align-items: center;
    width: ${theme.sz.s10};
    height: ${theme.sz.s10};
    padding: ${theme.sz.s05};

    &:hover {
      opacity: 0.8;
    }
  `,
);

export const FlagImage = styled.img(
  ({ theme }) => css`
    height: 100%;
    width: 100%;
    background-color: ${theme.co.neutral60};
    border-radius: ${theme.bo.round};
  `,
);
